import { Component } from 'preact';

export default class StatsBox extends Component {
  state = {
    visible: false
  }

  componentWillMount () {
    const { fadeIn, visible } = this.props;

    if (fadeIn && visible) {
      setTimeout(() => this.setState({ visible: true }), fadeIn);
    }

    else {
      this.setState({ visible });
    }
  }

  componentWillReceiveProps ({ visible }) {
    if (visible !== this.state.visible) {
      this.setState({ visible });
    }
  }

  itemSummaryText ({ key, label, deaths, suicides }) {
    // const type = label || `${key[0].toUpperCase()}${key.slice(1)}`;
    // let desc = deaths ? `${deaths} death${deaths === 1 ? '' : 's'}` : '';

    // if (suicides) {
    //   desc += `${deaths ? ' + ' : ''}${suicides} suicide${suicides === 1 ? '' : 's'}`;
    // }

    // const desc = `${suicides ? 'suicide' : 'death'}${value === 1 ? '' : 's'}`;
    // const typeLabel = isSuicide ? '' : ` — ${type}`;

    return <span class="total">
      {
        deaths ?
          <span>{`${deaths} death${deaths === 1 ? '' : 's'}`}</span> :
          null
      }

      {
        suicides ?
        <span>{`${deaths ? ' + ' : ''}${suicides} suicide${suicides === 1 ? '' : 's'}`}</span> :
        null
      }
    </span>;
  }

  render ({ year, totalDeaths, totals, children }, { visible }) {
    // console.log('StatsBox', { visible, year, totalDeaths, totals });

    return <section class={`StatsBox${visible ? ' visible' : ''}`}>
      { totalDeaths > 0 &&
        <h3>
          { `${totalDeaths} death${totalDeaths === 1 ? '' : 's'} in ${ year }`}
        </h3>
      }

      {
        totalDeaths > 0 &&
          <ul class="totals">
            {
              totals
              .filter(({ checked }) => checked !== false)
              .map(({ key, char, label, value, deaths, suicides }) => value > 0 &&
                <li key={ key } title={ label }>
                  { 
                    char.split('')
                    .map(char => <span class="icon">{ char }</span>)
                  }
                  {
                    this.itemSummaryText({ key, label, deaths, suicides })
                  }
                </li>
              )
            }
          </ul>
      }

      {
        children
      }
    </section>;
  }
}



// WEBPACK FOOTER //
// ./components/StatsBox.js